module.exports = __webpack_public_path__ + "img/banner.ac77b8c6.png";